<template>
  <div
    class="inline-block focus-field"
    :class="{'focus-field--disabled': disable}"
    @click="onClick"
  >
    <q-item-label
      v-if="hasCaptionSlot || caption"
      caption
      class="text-weight-medium"
    >
      <slot v-if="hasCaptionSlot" name="caption" />
      <template v-else>
        {{ caption }}
      </template>
      <span v-if="required" class="required-astrx" />
    </q-item-label>
    <q-item-label
      v-if="hasLabelSlot || !!label || !!defaultLabel"
      :lines="ellipsis === false ? undefined : (ellipsis === true ? 1 : ellipsis)"
      :title="ellipsis !== false && !!label ? label : undefined"
    >
      <slot v-if="hasLabelSlot" />
      <template v-else>
        {{ label || defaultLabel }}
      </template>
    </q-item-label>
  </div>
</template>

<script>
/**
 * FocusField specifies a piece of data within a FocusContainer which can be interacted with (example: clicking the FocusField can automatically place focus on a field within the container's focused content
 *
 * SLOTS:
 * - caption
 * - label
 */
export default {
  props: {
    // If slot not defined, caption to display
    caption: {
      type: String,
      default: null
    },
    // If slot not defined, label to display
    label: {
      type: String,
      default: null
    },
    // Disable clicking the FocusField
    disable: {
      type: Boolean,
      default: false
    },
    // if label is null, display a default value in this FocusField
    defaultLabel: {
      type: String,
      default: null
    },
    // If FocusField is a required entity, display asterisk *
    required: {
      type: Boolean,
      default: false
    },
    // Render ellipsis text for the label
    ellipsis: {
      type: [Boolean, Number],
      default: false
    }
  },
  emits: ['click'],
  computed: {
    hasLabelSlot () {
      return !!this.$slots.default
    },
    hasCaptionSlot () {
      return !!this.$slots.caption
    }
  },
  methods: {
    onClick () {
      if (this.disable) {
        return
      }
      this.$emit('click')
    }
  }
}
</script>
